import React, { useEffect } from 'react'
import { SiteHeader } from '../components/site-header'
import { PageHero } from '../components/ui/page-hero'
import { getAllTestimonials } from '../lib/testimonials'
import { METADATA } from '../components/meta/metadata'
import { IntroSection } from '../components/successstories/intro-section'
import { FeaturedTestimonials } from '../components/successstories/featured-testimonials'
import { CarouselSection } from '../components/successstories/carousel-section'
import { CtaSection } from '../components/successstories/cta-section'

export default function SuccessStoriesPage() {
  const allTestimonials = getAllTestimonials();
  // The first two testimonials will be displayed as featured
  const featuredTestimonials = allTestimonials.slice(0, 2);
  // The rest will go into the carousel
  const carouselTestimonials = allTestimonials.slice(2);
  
  // Set metadata for the page
  useEffect(() => {
    document.title = METADATA.successStories.title;
    
    // Set meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', METADATA.successStories.description);
  }, []);
  
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <PageHero
          title="Client Success Stories"
          description="See how we help organisations achieve rapid results through Knowledge Architecture and practical AI implementation."
          backgroundImage="/images/backgrounds/flickr-3052653173.jpg"
          backgroundAlt="Client success"
        />
        
        <section className="py-20">
          <div className="container">
            <IntroSection />
            
            {/* Featured testimonials - displayed as full width quotes */}
            <FeaturedTestimonials testimonials={featuredTestimonials} />
            
            {/* Carousel for remaining testimonials */}
            <CarouselSection testimonials={carouselTestimonials} />
            
            <CtaSection />
          </div>
        </section>
      </main>
    </div>
  )
} 